import React, { useEffect, useRef } from 'react';
import Hand from '../../assets/hand.svg';
import { useAppContext } from '../../context';
import '../../styles/stamp.css';

interface AnimatedHandProps {
    isAnimating: boolean;
    onAnimationComplete: () => void;
    setShowStamp: (value: boolean) => void;
}

const stampAudio = new Audio('/sounds/stamp.mp3');
stampAudio.volume = 0.15;

export const AnimatedHand: React.FC<AnimatedHandProps> = ({
    isAnimating,
    onAnimationComplete,
    setShowStamp
}) => {
    const { musicPlay, isMobile } = useAppContext();
    const animationEndedRef = useRef<boolean>(false);

    useEffect(() => {
        if (isAnimating && !animationEndedRef.current) {
            animationEndedRef.current = true;

            const soundTimer = setTimeout(() => {
                if (musicPlay) {
                    stampAudio.play();
                }
            }, 900);

            const stampTimer = setTimeout(() => {
                setShowStamp(true);
            }, 1100);

            return () => {
                clearTimeout(soundTimer);
                clearTimeout(stampTimer);
                animationEndedRef.current = false;
            };
        }
    }, [isAnimating, musicPlay, setShowStamp]);

    return isAnimating ? (
        <div
            className={`stamp-hand ${isAnimating ? 'is-animating' : ''} ${isMobile ? 'hand-m' : 'hand-d'}`}
            onAnimationEnd={() => {
                animationEndedRef.current = false;
                onAnimationComplete();
            }}
        >
            <img src={Hand} alt="Hand" />
        </div>
    ) : null;
};